"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userImage = exports.imageContainer = exports.noImage = void 0;

var _emotion = require("emotion");

var noImage = function noImage(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("display:flex;width:36px;height:36px;justify-content:center;align-items:center;background:", theme.color.accentHover, ";color:white;border-radius:18px;")
  );
};

exports.noImage = noImage;
var imageContainer =
/*#__PURE__*/
(0, _emotion.css)("display:flex;width:36px;height:36px;justify-content:center;align-items:center;");
exports.imageContainer = imageContainer;
var userImage =
/*#__PURE__*/
(0, _emotion.css)("width:36px;height:36px;border-radius:18px;");
exports.userImage = userImage;